import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';

export const OFFICIAL_SOURCE_SETTING_HELP =
  '僅影片建立者可在「分享設定」中變更官方判決來源。';

interface Props {
  displayName: string;
  /** Show (i) tooltip about share settings. */
  showSettingHint?: boolean;
  /** Use body2 for header emphasis. */
  dense?: boolean;
  /** Pro mode / dark panels — higher-contrast label and (i) icon. */
  tone?: 'default' | 'dark';
}

export default function OfficialSourceInline({
  displayName,
  showSettingHint = true,
  dense = false,
  tone = 'default',
}: Props) {
  const labelVariant = dense ? 'caption' : 'body2';
  const isDark = tone === 'dark';
  const mutedColor = isDark ? 'rgba(255,255,255,0.72)' : 'text.secondary';
  const strongColor = isDark ? 'rgba(255,255,255,0.95)' : 'text.primary';

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ minWidth: 0, flexWrap: 'wrap' }}>
      <VerifiedIcon sx={{ fontSize: 14, color: 'secondary.main', flexShrink: 0 }} />
      <Typography
        variant={labelVariant}
        sx={{ whiteSpace: 'nowrap', lineHeight: 1.4, color: mutedColor }}
        noWrap
      >
        官方判決來源：
        <Typography
          component="span"
          variant={labelVariant}
          fontWeight={700}
          sx={{ ml: 0.25, color: strongColor }}
        >
          {displayName}
        </Typography>
      </Typography>
      {showSettingHint && (
        <Tooltip title={OFFICIAL_SOURCE_SETTING_HELP} arrow placement="top" enterTouchDelay={0}>
          <IconButton
            size="small"
            aria-label="官方判決來源說明"
            sx={{
              p: 0.25,
              flexShrink: 0,
              color: isDark ? 'rgba(255,255,255,0.78)' : 'text.secondary',
              '&:hover': {
                color: isDark ? '#fff' : 'text.primary',
                bgcolor: 'action.selected',
              },
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
